// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-3pv4a";
var _4 = "body-2On7a";
var _5 = "segment_name_withPrices-1R4DJ";
var _6 = "segment_root-16xwZ";
var _7 = "segment_name-B1BKK";
var _8 = "segment_price-2iUn6";
var _9 = "counter_wrapper-1aQkz";
var _a = "footer_root-O18-w";
var _b = "header_row-ou6Gy";
var _c = "header_price_label-cDB4U";
var _d = "header_perFlight-2WQs4";
var _e = "baggage_wrapper-3tBtE";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "body", _5 as "segment_name_withPrices", _6 as "segment_root", _7 as "segment_name", _8 as "segment_price", _9 as "counter_wrapper", _a as "footer_root", _b as "header_row", _c as "header_price_label", _d as "header_perFlight", _e as "baggage_wrapper" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "body": _4, "segment_name_withPrices": _5, "segment_root": _6, "segment_name": _7, "segment_price": _8, "counter_wrapper": _9, "footer_root": _a, "header_row": _b, "header_price_label": _c, "header_perFlight": _d, "baggage_wrapper": _e }
